module.exports = __webpack_public_path__ + "media/images/resell-select-d53e1c4a.png";